"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FrequencyContent = _interopRequireDefault(require("./FrequencyContent.js"));
var _CrosstabContent = _interopRequireDefault(require("./CrosstabContent.js"));
var _OvertimeContent = _interopRequireDefault(require("./OvertimeContent.js"));
var _GroupContent = _interopRequireDefault(require("./GroupContent.js"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Content = function Content(props) {
  var currentMetric = props.currentMetric,
    currentCrossMetric = props.currentCrossMetric,
    data = props.data,
    currentMetricSettings = props.currentMetricSettings,
    deployments = props.deployments;
  var loadingVizData = !data;
  var _useMemo = (0, _react.useMemo)(function () {
      if (loadingVizData) {
        return {};
      }
      var total = {
        total: 0,
        responses: 0,
        skipped: 0
      };
      if (data.frequency) {
        total.total = data.frequency.reduce(function (num, item) {
          return num + item.valueCount;
        }, 0);
        total.responses = data.frequency.filter(function (item) {
          return item.value;
        }).reduce(function (num, item) {
          return num + item.valueCount;
        }, 0);
        total.skipped = data.frequency.filter(function (item) {
          return !item.value;
        }).reduce(function (num, item) {
          return num + item.valueCount;
        }, 0);
      }
      return {
        totalData: total
      };
    }, [data]),
    totalData = _useMemo.totalData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '1em'
    }
  }, currentMetricSettings.showLabel ? /*#__PURE__*/_react["default"].createElement("h3", {
    className: _style["default"].title
  }, currentMetric.reportHeader) : null, currentMetricSettings.showQuestion ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].question
  }, currentMetric.question) : null, !loadingVizData && currentMetricSettings.showTotalResponses ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].summary
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, totalData.total), " total submissions"), /*#__PURE__*/_react["default"].createElement("div", null, "|"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, totalData.responses), " responses"), /*#__PURE__*/_react["default"].createElement("div", null, "|"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("b", null, totalData.skipped), " skipped")) : null), function () {
    if (loadingVizData) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '2em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true,
        type: "inline"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-center",
        style: {
          marginTop: '0.3em'
        }
      }, "Loading"));
    }
    var hasData = totalData.responses > 0;
    if (!hasData) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'center',
          margin: '5em',
          color: '#d9d9d9'
        }
      }, /*#__PURE__*/_react["default"].createElement("h2", null, "Zero responses for this metric"));
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, currentMetricSettings.aboveChart && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: currentMetricSettings.aboveChart
    }), currentMetricSettings.comparison === 'none' && /*#__PURE__*/_react["default"].createElement(_FrequencyContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      data: data
    }), currentMetricSettings.comparison === 'crosstab' && /*#__PURE__*/_react["default"].createElement(_CrosstabContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      currentCrossMetric: currentCrossMetric,
      data: data
    }), currentMetricSettings.comparison === 'overtime' && /*#__PURE__*/_react["default"].createElement(_OvertimeContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      data: data,
      deployments: deployments
    }), currentMetricSettings.comparison === 'grouptype' && /*#__PURE__*/_react["default"].createElement(_GroupContent["default"], {
      currentMetric: currentMetric,
      currentMetricSettings: currentMetricSettings,
      data: data,
      deployments: deployments
    }), currentMetricSettings.belowChart && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: currentMetricSettings.belowChart
    }));
  }());
};
Content.propTypes = {
  currentMetric: _propTypes["default"].object,
  currentCrossMetric: _propTypes["default"].object,
  data: _propTypes["default"].object,
  currentMetricSettings: _propTypes["default"].object,
  deployments: _propTypes["default"].array
};
var _default = Content;
exports["default"] = _default;